import React from 'react';
import { MdCheck } from 'react-icons/md';

const Progress = ({ stepNames, currentStep }) => {
  const total = stepNames.length;
  const steps = Array.from({ length: total }, (_, i) => i);

  return (
    <ul className="progress-tracker progress-tracker--text progress-tracker--spaced progress-tracker--center">
      {steps.map((index) => {
        let stepClassName = "progress-step";
        const markerContent = (index < currentStep) ? <MdCheck /> : index + 1;

        if (index === currentStep)
          stepClassName += ' is-active';
        if (index < currentStep)
          stepClassName += ' is-complete';

        return (
          <li className={stepClassName} key={index}>
            <span className="progress-marker">{markerContent}</span>
            <span className="progress-text">
              <h4 className="progress-title">{stepNames[index].title}</h4>
              {stepNames[index].description}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default Progress;
